import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class topicsList_template extends vnTemplate{

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected statusFilter: filterDropdown_template;
    
    protected getTemplateHtml(): string{
        return `

            <div class="sub-header w-justify">
                <div class="w-left">
                    <div>
                        <label class="form-label form-label-box">Site</label> 
                        ` + this.statusFilter.getHtmlBuild() + `
                    </div>
                </div>
                <div class="w-center"></div>
                <div class="w-right"></div>
            </div>
           
            <div class="list-header w-justify" >

                <div class="w-left" >
                    <button data-bind="click: onClickAdd" class="btn no-bg icon i-user-add" type="button">Add Topic</button>
                </div>

                <div class="w-center">
                    <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                        <div class="w-search-feild icon i-search2">
                            <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                            <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                            <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                            <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                        </div>
                    </div>
                </div>

                <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    <thead>
                        <tr>
                            <th><span></span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'status') }, css: { 'list-sort-desc': orderByAndDirection()=='status_DESC', 'list-sort-asc': orderByAndDirection()=='status_ASC' }">Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateSubmitted') }, css: { 'list-sort-desc': orderByAndDirection()=='dateSubmitted_DESC', 'list-sort-asc': orderByAndDirection()=='dateSubmitted_ASC' }">Date Submitted</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: topics">
    
                        <tr>
                            <td></td>
                            <td><span data-bind="text: title"></span></td>
                            <td><span data-bind="text: status.name"></span></td>
                            <td><span data-bind="text: dateCreated"></span></td>
                            <td><span data-bind="text: dateSubmitted"></span></td>
                            <td><span data-bind="text: dateUpdated"></span></td>
    
                            <td class="no-wrap">
                                <button data-bind="event: { click: $parent.onClickView }" class="btn no-bg icon i-edit" type="button"></button>
                                <button class="btn no-bg icon i-delete" type="button"></button>
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.statusFilter = new filterDropdown_template("statusFilter", this.getTemplateViewModel(), this.caller)

    }

    protected getTemplateName(): string{
        return "topicsList-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            orderBy: ko.observable("title")
            ,orderByAndDirection: ko.observable("title_ASC")
            ,orderByDirection: ko.observable("ASC")
            ,topics: ko.observableArray([ ])
            ,onClickReorder : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); }
            ,onClickView : function(data, event){ huit_neuf_this.onClickView(data.id); }
            ,onClickAdd : function(){ huit_neuf_this.onClickAdd(); }
        };
    }

    public getViewModelForRequest(){

        return {
            orderBy: this.getTemplateViewModel().orderBy
            ,orderByDirection: this.getTemplateViewModel().orderByDirection
            ,orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            ,filter : this.getTemplateViewModel().filter
            ,pagination: this.getTemplateViewModel().pagination
        }
    }

    public onClickAdd(){
        this.caller.addTopic();
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.userListReorder();
    }

    public onClickView(id){
        this.caller.viewTopic(id);
    }

    public setTopics(topics){
        this.getTemplateViewModel().topics(topics);
    }


}


// WEBPACK FOOTER //
// ./js/components/templates/topicsList_template.ts